<!--Questo input field è nascosto e serve solo per sfruttare il meccanismo di upload
    dell'html. Graficamente viene pilotato attraferso un input type text con un bottone
-->
<input type="file" #file hidden
        multiple = false
        (change)="onFileSelected($event)">
<div class="layout vertical center middle" (click)="file.click()">
    <div style="width: 80px; height: 80px; margin-bottom: 16px; position: relative;" class="layout vertical center middle">
        <img [src]="temporaryUrl || url" width="80px" style="position: absolute; border-radius: 50%;">
        <div style="width: 80px; height: 80px; border-radius: 50%; border: 1px solid darkgray; position: absolute;"></div>
    </div>
</div>